import { ChangeDetectionStrategy, Component, Input, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';

import { TopTransactionModel } from '../../models/top-transaction.model';
import { TransactionModel } from '../../models/transaction.model';
import { TransactionsResource } from '../../services/resources/transactions.resource';

@Component({
    selector: 'sl-top-transactions',
    templateUrl: './top-transactions.component.html',
    styleUrls: ['./top-transactions.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TopTransactionsComponent implements OnInit {
    @Input() top = 10;
    // eslint-disable-next-line @typescript-eslint/naming-convention
    @Input() displayGraph = false;

    topTransactions: TopTransactionModel[] = [];
    displayedColumns: string[] = ['valueDate', 'type', 'outgoingName', 'numberOfShares', 'arrow', 'incomingName'];

    private readonly transactionsResource = inject(TransactionsResource);
    private readonly router = inject(Router);

    ngOnInit(): void {
        this.transactionsResource.top(this.top).subscribe(resp => (this.topTransactions = resp.value));
    }

    goToView(item: TransactionModel): void {
        this.router.navigate(['transactions', item.id]).then();
    }
}
